import { animate, inView, delay, press } from "motion"

/* Fade In */
inView(".fade-in", (element) => {
    animate(
        element,
        { 
            opacity: [0, 1], 
            transform: ["translateY(30px)", "translateY(0)"]
        }, {
            delay: 0.5,
            type: "spring",
            visualDuration: 0.8,
            bounce: 0.35
        }
    );
});

/* Homepage Hero Content */
inView(".hero-content", (element) => {
    animate(
        element,
        { 
            opacity: [0, 1], 
            transform: ["translateY(30px)", "translateY(0)"]
        },
        { delay: 0.5, type: "spring", visualDuration: 0.8, bounce: 0.35 }
    );
});

/* Homepage Hero Image */
inView(".hero-image", (element) => {
    animate(
        element,
        { 
            opacity: [0, 1], 
            transform: ["translateX(50px)", "translateX(0)"]
        }, {
            delay: 1,
            type: "spring",
            visualDuration: 0.8,
            bounce: 0.35
        }
    );
});

/* Homepage About Sections */
inView(".item-text", (element) => {
    const id = element.getAttribute('data-id');
    animate(
        ".item-image-" + Number(id),
        { 
            opacity: 1
        },{
            duration: 0.3
        }
    );
    
    return () => animate(".item-image-" + Number(id), { opacity: 0 });
});